export default __webpack_public_path__ + "static/media/Pro-black.fb446e7d.png";